export class NameValInteger {
  public Name: string;
  public Value: number;

  public constructor(itemName?: string, itemValue?: number) {
    if (itemName == null || itemName == undefined) {
      this.Name = '';
    } else {
      this.Name = itemName;
    }
    if (itemValue == null || itemValue == undefined) {
      this.Value = null;
    } else {
      this.Value = itemValue;
    }
  }
}
